import Tr from 'translations/Translations';
import {createSelectItem} from "../components/Select";

export const PriceType = {
    NET: 'NET',
    NET_VAT: 'NET_VAT',
    NET_GROSS: 'NET_GROSS',
    GROSS_VAT: 'GROSS_VAT',
    GROSS: 'GROSS',
}
const _TR_PREFIX = 'price_type_';

export const PriceTypeLabel = (priceType) => (Tr(_TR_PREFIX + priceType.toLowerCase()));

export const PriceTypeItems = [
    createSelectItem(PriceType.NET, PriceTypeLabel(PriceType.NET)),
    createSelectItem(PriceType.NET_VAT, PriceTypeLabel(PriceType.NET_VAT)),
    createSelectItem(PriceType.NET_GROSS, PriceTypeLabel(PriceType.NET_GROSS)),
    createSelectItem(PriceType.GROSS_VAT, PriceTypeLabel(PriceType.GROSS_VAT)),
    createSelectItem(PriceType.GROSS, PriceTypeLabel(PriceType.GROSS))
]

const UseNetOverGrossForAuctionPopup = {
    NET: true,
    GROSS: false
}

export const PriceTypeItemsForAuction = [
    createSelectItem(UseNetOverGrossForAuctionPopup.GROSS, PriceTypeLabel(PriceType.GROSS)),
    createSelectItem(UseNetOverGrossForAuctionPopup.NET, PriceTypeLabel(PriceType.NET))
]


const NET_FIELD_VISIBLE = [PriceType.NET, PriceType.NET_VAT, PriceType.NET_GROSS];
const GROSS_FIELD_VISIBLE = [PriceType.GROSS, PriceType.GROSS_VAT, PriceType.NET_GROSS];
const VAT_FIELD_VISIBLE = [PriceType.NET_VAT, PriceType.GROSS_VAT, PriceType.NET_GROSS];

export const PriceTypeNetFieldVisible = (priceType) => NET_FIELD_VISIBLE.includes(priceType);
export const PriceTypeGrossFieldVisible = (priceType) => GROSS_FIELD_VISIBLE.includes(priceType);
export const PriceTypeVatFieldVisible = (priceType) => VAT_FIELD_VISIBLE.includes(priceType);


const NET_SUM_PRICE_TYPES = [PriceType.NET, PriceType.NET_VAT]
export const NetSumPriceVisible = (priceType) => NET_SUM_PRICE_TYPES.includes(priceType);

const TOTAL_NET_FIELD_VISIBLE = [PriceType.NET, PriceType.NET_VAT, PriceType.NET_GROSS];
const TOTAL_GROSS_FIELD_VISIBLE = [PriceType.NET_GROSS, PriceType.GROSS_VAT, PriceType.GROSS];
export const TotalPriceTypeNetFieldVisible = (priceType) => TOTAL_NET_FIELD_VISIBLE.includes(priceType);
export const TotalPriceTypeGrossFieldVisible = (priceType) => TOTAL_GROSS_FIELD_VISIBLE.includes(priceType);